window.addEventListener('load', function(){
    
  // 使用したいcssを記述
  const css = `    
    /* form */
    .bhlqOe {
      font-size: 14px;
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;
    }
    .bEHcwt{
      align-items: center;
    }
    .sc-bdnxRM{
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;      
      font-size: 14px;
    }
    .cxgFby{            
      background: none;      
    }
    /* modal */
    .bvXunr{
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;            
    }
    .kKEalX{
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;            
    }
    .egnNqB{
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;            
    }
    .kLGJPn{
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;            
    }
    .elkTka{
      font-family: "Hiragino Mincho ProN","Hiragino Mincho Pro","Yu Mincho",YuMincho,Meiryo,sans-serif;            
    }
    @media screen and (max-width: 740px) {
      /* form */
      .gLKSHc{
        margin-bottom: 10px;
      }
      .jFFkHn{
        margin-left: 0;
      }
      .bhlqOe {
        font-size: 12px;        
      }
      .sc-bdnxRM + .sc-bdnxRM{
        margin-left: 10px;
      }
      .sc-bdnxRM{
        padding: 12px;
      }
      .sc-bdnxRM .title{
        font-size: 12px;
      }
      .sc-bdnxRM .price-amt{
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
      }
    }
  `;
  
  // styleタグの作成
  const customStyle = document.createElement('style');
  customStyle.type = 'text/css';
  customStyle.appendChild(document.createTextNode(css));
  
  // 作成したstyleタグをprotegerのsdkに反映
  const protegerIFrame = document.querySelector('#proteger-offer iframe');    
  protegerIFrame.contentDocument.head.appendChild(customStyle);
    
}); 